.roomFrame {
  width: 100%;
  height: 600px;
  border-radius: 0.5rem;
  overflow: hidden;
}

.conference {
  min-width: 0;
}

.layout {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.videoPane {
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.videoPane :global(.lk-grid-layout-wrapper),
.videoPane :global(.lk-focus-layout-wrapper) {
  flex: 1;
  height: auto;
  min-height: 0;
}

.videoPane :global(.lk-control-bar) {
  flex: 0 0 auto;
}

.chatPane {
  flex: 0 0 20rem;
  width: 20rem;
  max-width: 100%;
  height: 100%;
  min-height: 0;
}

.chatPane[hidden] {
  display: none;
}

.chatPane :global(.lk-chat) {
  position: relative;
  inset: auto;
  grid-template-rows: var(--lk-chat-header-height) minmax(0, 1fr) var(--lk-control-bar-height);
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.chatPane :global(.lk-chat-messages) {
  min-height: 0;
  overflow-wrap: anywhere;
}

.chatPane :global(.lk-chat-form-input) {
  min-width: 0;
}

@media (max-width: 767px) {
  .chatPane {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
}
